import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=0f63ad1c&"
import script from "./TabPane.vue?vue&type=script&lang=js&"
export * from "./TabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f63ad1c')) {
      api.createRecord('0f63ad1c', component.options)
    } else {
      api.reload('0f63ad1c', component.options)
    }
    module.hot.accept("./TabPane.vue?vue&type=template&id=0f63ad1c&", function () {
      api.rerender('0f63ad1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabs/TabPane.vue"
export default component.exports